import { useEffect } from "react";
import { Box, Divider } from "@mui/joy";

import { TaskActionComponent, TaskHeader } from "../../Tasks/components";
import { PermitPhotos } from "./PermitPhotos";

interface ITaskComponent {
    activeTask: any;
    onComplete: any;
    actionProgress: any;
}

export default function BuildingPermitTaskComponent(props: ITaskComponent) {
    const { activeTask, onComplete, actionProgress } = props;
    const { Id, ProjectId } = activeTask || {};

    useEffect(() => {
        const scrollableDiv = document.getElementById("project-details-parent");
        if (scrollableDiv) {
            scrollableDiv.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, []);

    return (
        <Box sx={{ position: "relative", minHeight: 400 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    mt: 1,
                    px: { xs: 2, sm: 3 },
                    animation: "fadeIn 0.5s ease-in-out",
                    "@keyframes fadeIn": {
                        "0%": { opacity: 0 },
                        "100%": { opacity: 1 },
                    },
                }}
            >
                <TaskHeader activeTask={activeTask} />
                <Divider />

                <PermitPhotos taskId={Id || ""} projectId={ProjectId || ""} />

                <Box mt={4}>
                    <Divider />
                    <TaskActionComponent
                        taskName={activeTask?.Name || ""}
                        onComplete={onComplete}
                        actionProgress={actionProgress}
                        isNextEligible={true}
                        taskId={Id || ""}
                    />
                </Box>
            </Box>
        </Box>
    );
}
